import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { type RemotenessTypes } from '@/microfrontends/listing/shared/types/RemotenessTypes';

type RemotenessIconProps = {
  iconType: RemotenessTypes;
};

export const RemotenessIcon: FC<RemotenessIconProps> = props => {
  const { iconType } = props;

  switch (iconType) {
    case 'walk':
      return <IconMapWalk16 color="gray60_100" />;
    case 'transport':
      return <IconMapCar16 color="gray60_100" />;
  }
};
